<template>
<div>
    <Modal
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'top':'20%','min-width':'700px'}">
        
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
    
           <FormItem :label="$t('deviceManage.addModel.groupName')" prop="deviceGroupId"  style="width: 500px">
                <SearchSelect ref="productType" :url="searchProductTypeUrl" labelName='groupName' labelNameNew="productType" isMultiple='2'  valName='id' keyword="groupName" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectVal($event,'deviceGroupId')"></SearchSelect>
            </FormItem>

            <FormItem>
                <Button :loading="disabled"  type="primary" @click="subData('formData')" style="marginRight:20px">{{$t('save')}}</Button>
                <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
            </FormItem>
        </Form>

    </Modal>
</div>
</template>
<script>
/**
 * 弹框，设备移动组织
 * 
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import SearchSelect from '../../common/selectList.vue';
    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Array
        },
        name: "Model3",
        components: {
            SearchSelect
        },
        data() {
            return {   
                searchProductTypeUrl: this.config.urlArray.deviceGroupsList,
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                formData: {//表单数据
                   deviceGroupId:'',
                   deviceGroupName:''
                }
            }
        },
        computed:{
            ruleCustom(){
                return {//验证
                    deviceGroupId: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ]
                }
            } 

        },
        created(){
           
        },
        methods: {
            setSelectVal(e,key){
                //  console.log('e',e)
                 this.formData[key] = e.nameVal+''
                 this.formData['deviceGroupName'] = e.nowData.label
            },
            openOrClose(value) {
                if(value === true) {
                    this.$nextTick(()=>{//select赋值，图片赋值
                        this.$refs.productType.setQuery(null)
                    });   
                    this.title = this.type == 1?this.$t('deviceManage.addModel.title'):''
                } else { 
                    this.resetForm();//重置表单
                    this.$refs.productType.clearVal();
                }
            },
            subData(name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;          
                        let formDataArr = []
                        this.editFormData.map(item=>{
                            formDataArr.push(item.deviceId)
                        })     

                        let data = {
                            "deviceGroupId":this.formData.deviceGroupId,
                            "deviceIds":formDataArr
                        }
                        // console.log(data)

                        this.axios.post(this.config.urlArray.deviceGroupsMove, data).then((result) => {
                           
                            common.ajaxMsg(result.data,true,()=>{
                                this.resetForm();
                                this.fn()
                            },()=>{this.disabled = false;})
                            
                        })
                        
                    }
                })
            },
            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();
                this.disabled = false;
                
            }
        }
    }
</script>
<style scoped>
.simple-size {
    color: #ccc;
    font-size: 12px;
    height: 20px;
    padding: 0;
    margin: 0;
}
</style>

